export class LoadAllClientsAction {
  static readonly type = '[Clients] Load all clients';
  constructor() {}
}

export class LoadLastClientsAction {
  static readonly type = '[Clients] Load last clients';
  constructor() {}
}

export class SearchAllClientsAction {
  static readonly type = '[Clients] Search all clients';
  constructor(public search: string) {}
}

export class SearchLastClientsAction {
  static readonly type = '[Clients] Search last clients';
  constructor(public search: string) {}
}

export class ResetClientsAction {
  static readonly type = '[Clients] Reset clients list';
  constructor() {}
}
